import { render, staticRenderFns } from "./my-nav-menu.vue?vue&type=template&id=23182eae&scoped=true&"
import script from "./my-nav-menu.vue?vue&type=script&lang=js&"
export * from "./my-nav-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23182eae",
  null
  
)

export default component.exports